import React from 'react';

const Process = () => {
  const steps = [
    {
      title: "Diagnóstico",
      description:
        "Analizamos cómo trabajás hoy y detectamos dónde se pierde tiempo o se generan errores.",
    },
    {
      title: "Diseño de solución",
      description:
        "Definimos un sistema adaptado a tu forma de trabajo, con foco en simplicidad y control.",
    },
    {
      title: "Desarrollo e implementación",
      description:
        "Construimos el sistema, lo ajustamos con vos y lo dejamos funcionando en condiciones reales.",
    },
    {
      title: "Seguimiento",
      description:
        "Acompañamos la implementación y realizamos mejoras para que el sistema funcione cada vez mejor.",
    },
  ];

  return (
    <section id="process" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1.1fr,0.9fr] gap-12 items-start">
          <div>
            <span className="inline-flex px-4 py-2 rounded-full bg-blue-50 text-blue-700 text-sm font-semibold mb-4">
              Cómo trabajamos
            </span>

            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-5">
              Un proceso claro, sin vueltas innecesarias
            </h2>

            <p className="text-xl text-slate-600 leading-relaxed max-w-2xl">
              Primero entendemos el problema. Después definimos la solución. Y recién ahí desarrollamos.
            </p>
          </div>

          {/* 🔥 CAJA DERECHA CORREGIDA (chau tono defensivo) */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-sm border border-slate-200">
            <p className="text-slate-700 leading-relaxed text-lg">
              Trabajamos con foco en soluciones simples y funcionales. El objetivo es que el sistema se adapte a tu forma de trabajar, reduzca errores y sea fácil de usar desde el primer día.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6 mt-14">
          {steps.map((step, index) => (
            <article
              key={step.title}
              className="bg-white rounded-3xl p-6 border border-slate-200 shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 rounded-2xl bg-slate-900 text-white flex items-center justify-center font-bold text-lg mb-5">
                {String(index + 1).padStart(2, '0')}
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {step.title}
              </h3>

              <p className="text-slate-600 leading-relaxed">
                {step.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;